/* eslint-disable @angular-eslint/no-output-native */
import {
  ControlValueAccessor,
  FormControl,
  FormsModule,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  forwardRef,
} from '@angular/core';

import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { RxIconComponent } from '../rx-icon/rx-icon.component';

@Component({
  selector: 'rx-textarea',
  templateUrl: './rx-textarea.component.html',
  styleUrls: ['./rx-textarea.component.scss'],
  imports: [CommonModule, FormsModule, RxIconComponent],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RxTextareaComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => RxTextareaComponent),
      multi: true,
    },
  ],
})
export class RxTextareaComponent implements OnDestroy, ControlValueAccessor, Validator {
  private destroyed$: Subject<boolean> = new Subject<boolean>();
  public payload: any;

  @Input() id = 'item' + Math.random().toString(36).substring(2);
  @Input() value: any;
  @Input() labelText: string;
  @Input() placeholder: string;
  @Input() maxLength;
  @Input() minLength;
  @Input() hasInlineInfo = false;
  @Input() keepPlaceholder = false;
  @Input() prefix: string;
  @Input() showReset = false;
  @Input() type = 'text';
  @Input() disable: boolean;
  @Input() required = false;
  @Input() autocomplete: string;

  @Output() valueChange: EventEmitter<any> = new EventEmitter();
  @Output() blur: EventEmitter<any> = new EventEmitter();
  @Output() focus: EventEmitter<any> = new EventEmitter();

  @ViewChild('label', { static: false }) public label: ElementRef;

  public control: FormControl;
  public width = 100;
  public isRequired = false;
  public isRequiredChecked = false;

  constructor() {}

  public get isPending() {
    return this.control && this.control.pending;
  }

  // ngOnChanges(changes: SimpleChanges | any): void {
  //     // trigger validation
  //     // this.onChange(this.value);
  // }

  onModelChanged($event) {
    //this.writeValue($event);
    this.onChange($event);
  }

  // input changes.
  onChange = (value: string) => {};

  // touched/clicked.
  onTouched = () => {};

  // Register for change
  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  // Register for touch/click
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  // Update the model and changes
  writeValue(value: string): void {
    if (this.value !== value) {
      this.value = value;
      this.onChange(this.value);
    }
  }

  isValid(): boolean {
    return this.control && !this.control.pending && !this.control.errors && !this.control.invalid;
  }

  // validate
  public validate(control: FormControl): any {
    this.control = control;

    // TODO
    if (!this.isRequiredChecked) {
      this.isRequiredChecked = true;
      this.isRequired = this.control.errors && this.control.errors['required'];
    }
    return control.valid ? null : control.errors;
  }

  onReset() {
    this.value = null;
    this.onChange(this.value);
  }

  public getPlaceholderText() {
    let result = this.placeholder;
    const currentlenght = this.value && true ? this.value.length : 0;
    if (this.hasInlineInfo) {
      result +=
        currentlenght === 0
          ? ` (${this.maxLength - currentlenght} characters left)`
          : `(${this.maxLength - currentlenght} characters left)`;
    }
    return result || '';
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onBlur() {
    this.blur.emit();
    // this.value = this.value.trim();
    // this.onChange(this.value);
    // this.onTouched();
  }
}
